var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgHeatpump = function SvgHeatpump(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg4",
    width: 32,
    height: 32,
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path972",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2.651,
    d: "M6.278 1.326h19.338c2.074 0 3.763 1.702 3.763 3.775V24.43a3.77 3.77 0 0 1-3.763 3.761H6.278c-2.074 0-3.777-1.688-3.777-3.76V5.1a3.79 3.79 0 0 1 3.777-3.775z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "path974",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.651,
    d: "m6.855 30.675 2.39-2.389"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "path976",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.651,
    d: "M19.682 1.614v25.85"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "path978",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.651,
    d: "M11.401 8.931c-.247-1.441 3.269-1.95 3.434-.604"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "path980",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.651,
    d: "M10.439 8.945c1.126.933-1.195 3.596-2.197 2.704"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "path982",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.651,
    d: "M10.549 8.794c-.604 1.318-3.79-.234-3.173-1.442"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "path984",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.651,
    d: "M11.222 8.684c-1.456-.082-1.167-3.61.179-3.487"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "path986",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.651,
    d: "M10.975 9.192c1.222-.81 3.104 2.196 1.95 2.896"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "path988",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.651,
    d: "m25.615 30.675-2.39-2.389"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "path990",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.651,
    d: "M11.401 21.245c-.247-1.428 3.269-1.936 3.434-.59"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "path992",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.651,
    d: "M10.439 21.272c1.126.92-1.195 3.597-2.197 2.704"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "path994",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.651,
    d: "M10.549 21.121c-.604 1.318-3.79-.247-3.173-1.455"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "path996",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.651,
    d: "M11.222 20.998c-1.456-.069-1.167-3.597.179-3.473"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "path998",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.651,
    d: "M10.975 21.519c1.222-.81 3.104 2.183 1.95 2.897"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgHeatpump);
export default ForwardRef;